import React, { useEffect, useRef } from 'react';
import { Button } from '../../../shared/components/ui/Button';
import { toast } from 'react-hot-toast';

interface GoogleOAuthConfig {
  client_id: string;
  callback: (response: unknown) => void;
}

interface GoogleOAuthButtonOptions {
  type: string;
  theme: string;
  size: string;
  text: string;
  shape: string;
  logo_alignment: string;
}

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: GoogleOAuthConfig) => void;
          renderButton: (element: HTMLElement, options: GoogleOAuthButtonOptions) => void;
          prompt: () => void;
        };
      };
    };
  }
}

export const GoogleOAuthButton: React.FC = () => {
  const buttonRef = useRef<HTMLDivElement>(null);
  const size = 'large';

  useEffect(() => {
    // Initialize Google OAuth
    if (window.google && buttonRef.current) {
      window.google.accounts.id.initialize({
        client_id: import.meta.env.VITE_GOOGLE_CLIENT_ID || '',
        callback: (response: unknown) => {
          // Handle Google sign-in response
          console.log('Google sign-in response:', response);
        }
      });

      window.google.accounts.id.renderButton(buttonRef.current, {
        type: 'standard',
        theme: 'outline',
        size: 'large',
        text: 'signin_with',
        shape: 'rectangular',
        logo_alignment: 'left',
      });
    }
  }, [size]);

  const handleManualGoogleSignIn = () => {
    if (window.google) {
      window.google.accounts.id.prompt();
    } else {
      toast.error('Google Sign-In is not available. Please try again.');
    }
  };

  return (
    <div className="w-full">
      <div ref={buttonRef} className="w-full" />
      {!window.google && (
        <Button
          onClick={handleManualGoogleSignIn}
          variant="outline"
                      size="lg"
          className="w-full"
        >
          <svg
            className="w-5 h-5 mr-2"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" />
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" />
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" />
          </svg>
          Sign in with Google
        </Button>
      )}
    </div>
  );
}; 